import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { getAdobeSiteSection } from '@cigna/cigna-for-brokers/shared/util';

@Component({
  selector: 'cigna-statement-access-request-dialog',
  templateUrl: 'statement-access-request-dialog.component.html',
  styleUrls: ['./statement-access-request-dialog.component.scss'],
})
export class StatementAccessRequestDialogComponent implements OnInit {
  isImpersonatorFlag: boolean;
  constructor(
    public dialogRef: MatDialogRef<StatementAccessRequestDialogComponent>,
    private analytics: ShellTrackHandlers,
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isImpersonatorFlag: boolean;
    },
  ) {}

  ngOnInit(): void {
    this.isImpersonatorFlag = this.data.isImpersonatorFlag;
  }

  onCancelClick(): void {
    const adobeSection = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther({}, 'Cancel', 'ac24433', {
      eVar119: 'MTD-1450',
      eVar120: 'request-statement-access-modal-links',
      prop67: 'action',
      channel: adobeSection.channel,
      pageName: adobeSection.pageName,
      prop20: 'request statement access modal',
    });

    this.dialogRef.close();
  }

  onManageClick(): void {
    const adobeSection = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther({}, 'Request Access', 'ac24433', {
      eVar119: 'MTD-1450',
      eVar120: 'request-statement-access-modal-links',
      prop67: 'action',
      channel: adobeSection.channel,
      pageName: adobeSection.pageName,
      prop20: 'request statement access modal',
    });

    this.dialogRef.close(true);
  }
}
